import { render, staticRenderFns } from "./TruncatedLink.vue?vue&type=template&id=358f461d&scoped=true"
import script from "./TruncatedLink.vue?vue&type=script&lang=js"
export * from "./TruncatedLink.vue?vue&type=script&lang=js"
import style0 from "./TruncatedLink.vue?vue&type=style&index=0&id=358f461d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f461d",
  null
  
)

export default component.exports